<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar class="hidden-lg hidden-xl"></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container agendar">
                <div class="dashboard-content-inner">  



                    <div class="header-image hidden-lg hidden-xl" v-if="data.detalhes" :style="{'background-image': 'url(' + data.detalhes.imagem + ')'}">
                        <div class="layer-gradient2"></div>
                    </div>
                    <a v-on:click="$root.back()" class="button block-mobile small gray margin-bottom-0 margin-top-20 hidden-xs hidden-md voltar-top">
                        <i class="las la-arrow-left"></i>
                        Voltar
                    </a>
                        
                    <!-- Row -->
                    <div class="row" v-if="data.detalhes">

                        <div class="col-xl-12">                                          
                            <h3 class="margin-bottom-0 margin-top-20">{{data.detalhes.nome}}</h3>
                            <p class="margin-top-0 margin-bottom-5">
                                {{data.detalhes.descricao}}
                            </p>
                            <small class="block">
                                <i class="las la-clock"></i>
                                {{data.detalhes.horarioAtendimento}}
                            </small>                            
                            <span class="dashboard-status-button gray">
                                {{data.detalhes.categorias}}
                            </span>
                        </div>

                        <div class="col-lg-6 col-xs-12 col-xl-6">
                            <p class="page-text margin-bottom-15 margin-top-20" v-show="Object.keys(data.itens).length > 0">
                                Escolha abaixo o dia e horário de preferência para prosseguir com o agendamento.
                            </p>
                            <p class="page-text margin-bottom-15 margin-top-20" v-show="Object.keys(data.itens).length == 0">
                                O profissional não possui opções para agendamento.
                            </p>                            
                        </div>

                        <div class="col-xs-12 margin-bottom-10" v-for="(item, index) in Object.keys(data.itens)">
                            <h5 class="margin-bottom-5">
                                {{item}}
                            </h5>
                            <span v-for="(item2, index2) in data.itens[item]" v-on:click="agendar(item2);" class="dashboard-status-button margin-bottom-10">
                                {{item2.HR_HORA}}h
                            </span>
                                                                                                                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Agenda',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    }, 
    computed: {
        swiper() {
            return this.$refs.swiperHorarios.$swiper
        }
    },       
    data () {
        var self                    = this;
        return {        
            "data":                 {
                "detalhes":         null,
                "itens":            []
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token
            },
        }
    },
    watch: {
                  
    },
    methods: {
        agendar: function(data) {
            var self        = this;

            loading.show();

            self.$root.modalAgendarData = {
                "detalhes":     self.data.detalhes,
                "agendamento":  data
            };

            self.$root.$forceUpdate();
            if (!self.$root.logged) {
                window.localStorage.setItem("_redirect", JSON.stringify({
                    "route":    "Agenda",
                    "query":    {
                        "c":    self.$route.query.c
                    },
                    "data":     self.$root.modalAgendarData
                }));
            }

            if (!self.$root.logged) {
                self.$root.go("Login");
                return false;
            }

            self.$root.modalAgendar   = new tingle.modal({
                footer:         false,
                stickyFooter:   false,
                closeMethods:   ['overlay', '', 'escape'],
                closeLabel:     "",
                cssClass:       ["modal-agendar"]
            });   

            setTimeout(function() {
                self.$root.modalAgendar.setContent(document.querySelector('#modal-agendar').innerHTML);      
                self.$root.modalAgendar.open();
                loading.hide();
                setTimeout(function() {
                    $(".modal-agendar").append('<a class="close" onclick="window.__app.modalAgendar.close();"><i class="las la-times"></i></a>');    
                }, 100);
            }, 100);

        },        
        get: function() {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {


                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "usuarioCod":   self.$route.query.c,
                        "NR_SEQUENCIA":    null
                    }
                };

                if (window.localStorage.getItem("_redirect") && self.$route.query.r == "1") {
                    try {
                        var redirect = JSON.parse(window.localStorage.getItem("_redirect"));
                    console.log("Possui redirect", redirect)
                        if (redirect.data.agendamento.NR_SEQUENCIA) {
                            form.params.NR_SEQUENCIA = redirect.data.agendamento.NR_SEQUENCIA;
                            window.localStorage.removeItem("_redirect");
                        }
                    } catch(err) {
                        console.log("Erro ao ler _redirect", err);
                    }
                }
                window.localStorage.removeItem("_redirect");


                axios.get("api/agenda.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = response.data.result;
                    console.log("Setou data", self.data)

                    if (form.params.NR_SEQUENCIA && response.data.result.disponivel) {
                        self.agendar(redirect.data.agendamento);                        
                    }

                    self.$forceUpdate();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }       
    },
    created: function() {
        var self = this;

        if (!self.$route.query.c) {
            self.$root.back();
            return false;
        }

        loading.show();

        Promise.all([
            self.get()
        ]).then(function() {
        
            self.$forceUpdate();
            loading.hide();
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .header-image {
        border-radius: 0px !important;
        margin-top: 0px;
        margin-left: -20.5px !important;
        margin-right: -20.5px !important;
    }
    .dashboard-content-container {
        margin-top: -60px;
    }
    .dashboard-content-inner {
        padding-top: 0px !important;
    }

    .swiper-container {
        /*width: 100%;*/
        display: block;
        padding-left: 20px;
        padding-right: 20px;
        margin-left: -20px;
        margin-right: -20px;
        height: 100%;
        overflow: inherit !important;
    }

    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: transparent;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        width: auto !important;
        height: 50px;
    }   

    .dashboard-status-button:not(.gray) {
        box-shadow: 4px 4px rgba(255,255,255,0.5);  
        margin-right: 10px;
        top: 0px;
        background: #59ba92;
        padding: 8px 20px;
        font-size: 16px;
    }   
</style>



// WEBPACK FOOTER //
// src/components/Agenda.vue